import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function HotRecommend() {
  const featured = comics.filter((c) => c.featured).slice(0, 8);

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600 mt-1">
              精选优质韩漫，每日更新推荐
            </p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors duration-200"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((comic) => (
            <ComicCard key={comic.id} {...comic} />
          ))}
        </div>
      </div>
    </section>
  );
}